import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { notBlank } from "../util/ext";
import { equals, find, propEq } from "ramda";
import TextField from "@mui/material/TextField";
import { useAllModules } from "./subscriptionService";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import { matchSorter } from "match-sorter";
import VirtualizedListbox, {
  LISTBOX_BORDER_STYLE,
} from "../components/VirtualizedListbox";

const filterOptions = (options, { inputValue }) =>
  matchSorter(options, inputValue, {
    keys: ["name", "displayName", "id", "status"],
  });

const ModuleAutoComplete = props => {
  const {
    autoFocus = false,
    disabled = false,
    error,
    helperText,
    label = "Module",
    onChange,
    onBlur,
    value,
  } = props;
  const modules = useAllModules();
  const [selectedModule, setSelectedModule] = useState(null);

  useEffect(() => {
    if (modules.isSuccess) {
      setSelectedModule(find(propEq("id", value), modules.data));
    }
  }, [modules.isSuccess, modules.data, value]);

  const handleModuleSelect = useCallback(
    (_event, module) => {
      setSelectedModule(module);
      onChange(module ? module.id : null);
    },
    [onChange],
  );

  return (
    <Fragment>
      {modules.isLoading ? (
        <Skeleton variant="text" />
      ) : (
        <Autocomplete
          disabled={disabled}
          disableListWrap
          options={modules.data}
          value={selectedModule || null}
          ListboxComponent={VirtualizedListbox}
          ListboxProps={{ itemSize: 60, listStyle: LISTBOX_BORDER_STYLE }}
          getOptionLabel={module => notBlank(module) && `${module.name}`}
          isOptionEqualToValue={(opt, val) =>
            notBlank(val) && equals(opt.id, val.id)
          }
          filterOptions={filterOptions}
          renderOption={({ key, ...props }, option) => (
            <li key={key} {...props}>
              <Box width="100%">
                <Box fontSize="1.4rem">
                  <Typography
                    noWrap
                    color={option.status === "INACTIVE" ? "error" : "inherit"}
                  >
                    {option.name}
                  </Typography>
                </Box>
                <Box fontSize="1.2rem">
                  <Typography
                    color={option.status === "INACTIVE" ? "error" : "inherit"}
                  >{`(${option.id})`}</Typography>
                </Box>
              </Box>
            </li>
          )}
          onChange={handleModuleSelect}
          onBlur={onBlur}
          renderInput={params => {
            params.inputProps["aria-autocomplete"] = "none";
            params.inputProps["id"] = null;
            return (
              <TextField
                {...params}
                autoFocus={autoFocus}
                type="text"
                name={"program-organization-" + Math.random()}
                label={label}
                error={error}
                helperText={helperText}
                fullWidth
              />
            );
          }}
        />
      )}
    </Fragment>
  );
};

ModuleAutoComplete.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  filterFunction: PropTypes.func,
  autoFocus: PropTypes.bool,
  helperText: PropTypes.string,
  error: PropTypes.bool,
};

export default ModuleAutoComplete;
